let prefersReducedMotion = window.matchMedia('(prefers-reduced-motion)').matches;
let largeScreenDevice = window.matchMedia('(min-width: 1024px)').matches;
let autoplayVideos = document.querySelectorAll('.jsAutoplayVideo');
let videoToggleButtons = document.querySelectorAll('.jsVideoToggleButton');

// Handle autoplay
if ( ! prefersReducedMotion )
{
	// Doesn't mind motion
	autoplayVideos.forEach(video => {
		video.setAttribute('autoplay', '');
		video.play();
		let btns = document.querySelectorAll('button[data-video]');
		btns.forEach(btn => {
			setButtonIcon(btn);
		});
	});
}

/* function showVideos()
{
	console.log('showVideos() is running');
	if ( largeScreenDevice )
	{
		console.log('Modifying video code to show videos');
		autoplayVideos.forEach(video => {
			let sources = video.querySelectorAll('source');
			sources.forEach(source =>
			{
				source.setAttribute('src', source.dataset.src);
			});
			video.load();
		});
		showVideos = function(){};
		console.log('showVideos() is negated');
	}
}

var ro = new ResizeObserver(entries => {
	entries.forEach(entry =>
	{
		console.log('Resized');
		const cr = entry.contentRect;
		if (cr.width >= 1024) {
			console.log('Resized & size is desktop+');
			showVideos();
		}
	});
});
ro.observe(document.querySelector('html')); */
// showVideos();
function setButtonIcon(btn)
{
	// Button
	let btnText = btn.querySelector('span');
	let btnIcon = btn.querySelector('.icon');
	let btnIconUse = btnIcon.querySelector('use');
	// Video
	let targetVideoId = btn.dataset.video;
	let targetVideo = document.querySelector('video#' + targetVideoId);

	if (targetVideo.paused)
	{
		btnText.innerText = 'Play';
		btnIcon.classList.replace('icon-pause', 'icon-play');
		btnIconUse.setAttribute('xlink:href', '#icon-play');
	}
	else
	{
		btnText.innerText = 'Pause';
		btnIcon.classList.replace('icon-play', 'icon-pause');
		btnIconUse.setAttribute('xlink:href', '#icon-pause');
	}
}

// Handle play button
videoToggleButtons.forEach(btn => {
	btn.addEventListener('click', () =>
	{
		let vid = document.querySelector('video#' + btn.dataset.video);
		vid.paused ? vid.play() : vid.pause();
		setButtonIcon(btn);
	});
});